// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"633":"47b8be9f","3694":"c5ecc008","5864":"47b8be9f"}[chunkId] + ".chunk.css";
};